__webpack_require__.p = "/cruel-solitaire/";